export enum ProductShopItemCategory {
	FOOD = 'food',
	ITEMS = 'items',
}

export enum ProductShopType {
	EVERYDAY = 'everyday',
	TOURIST = 'tourist',
	BAR = 'bar',
}
